<script>
import { mapActions } from "vuex";

export default {
  name: "data-filters",
  props: {
    //pickup here setup filter toggles on creatred enable and apply values if set
    dataFilters: {
      type: Object,
      default: () => ({}),
    },
  },
  data: () => ({
    endTimeModal: false,
    errorMessage: null,
    filters: {
      loadThreshold: 200,
      timeRange: ["00:00", "23:55"],
    },
    isLoading: false,
    loadThresholdEnabled: false,
    rememberFilters: false,
    // saveLoading: false,
    startTimeModal: false,
    timeRangeEnabled: false,
  }),
  computed: {
    saveDisabled() {

    }
  },
  methods: {
    saveFilters() {
      const filters = {
        loadThreshold: null,
        timeRange: [],
      };

      if (this.timeRangeEnabled) {
        if (this.filters.timeRange?.[0] > this.filters.timeRange?.[1]) {
          console.log(this.timeRange)
          this.errorMessage = 'Start time must come before End time.'
          return
        }
        filters.timeRange = [...this.filters.timeRange];
      }
      if (this.loadThresholdEnabled) {
        filters.loadThreshold = this.filters.loadThreshold ?? 0;
      }
      if (this.timeRangeEnabled) {
        filters.timeRange = [...this.filters.timeRange];
      }
      if (this.rememberFilters) {
        localStorage.setItem("usageFilters", JSON.stringify(filters));
      } else {
        localStorage.removeItem("usageFilters");
      }
      this.$emit("saveFilters", filters);
    },
  },
  created() {
    //todo, load localStorage here
    // const defaultOptions = structuredClone(this.filters)
    // this.filters = {...defaultOptions, ...this.dataFilters}
    console.log(this?.dataFilters?.loadThreshold);

    if (
      this?.dataFilters?.loadThreshold !== null &&
      this?.dataFilters?.loadThreshold !== undefined
    ) {
      this.$set(this.filters, "loadThreshold", this.dataFilters.loadThreshold);
      this.loadThresholdEnabled = true;
    }

    if (
      this.dataFilters?.timeRange &&
      Array.isArray(this.dataFilters?.timeRange) &&
      this.dataFilters.timeRange?.length === 2
    ) {
      this.$set(this.filters, "timeRange", [...this.dataFilters.timeRange]);
      this.timeRangeEnabled = true;
    } else {
      this.$set(this.filters, "timeRange", ["00:00", "23:55"]);
    }
    const savedFilters = localStorage.getItem("usageFilters");
    if (savedFilters) {
      this.rememberFilters = true;
    }
  },
};
</script>

<template>
  <v-sheet class="default-dialog">
    <v-icon color="primary" @click="$emit('close')" class="close-btn"
      >mdi-close</v-icon
    >
    <v-card>
      <v-card-title
        class="primary--text text-h4 d-flex flex-column align-start justify-start"
      >
        DATA FILTERS

        <p class="primary--text text-body-1 text-left mb-0">
          <!-- (Disabled demo mode) -->
        </p>
      </v-card-title>
      <v-card-text class="pa-6">
        <v-row>
          <v-col cols="12" class="text-left">
            <v-sheet class="filter pa-4 pt-0">
              <v-checkbox v-model="loadThresholdEnabled" label="Load Threshold">
              </v-checkbox>
              <v-text-field
                v-model="filters.loadThreshold"
                :disabled="!loadThresholdEnabled"
                outlined
                solo
                type="number"
                style="width: 100%; max-width: 300px"
              ></v-text-field>
            </v-sheet>
          </v-col>
          <v-col cols="12" class="text-left">
            <v-sheet class="filter pa-4 pt-0">
              <v-checkbox v-model="timeRangeEnabled" label="Time Range">
              </v-checkbox>
              <v-sheet class="d-flex">
                <v-dialog
                  ref="startTimeDialog"
                  v-model="startTimeModal"
                  :return-value.sync="filters.timeRange[0]"
                  persistent
                  width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="filters.timeRange[0]"
                      :disabled="!timeRangeEnabled"
                      label="Start"
                      prepend-icon="mdi-clock-time-four-outline"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-time-picker
                    v-if="startTimeModal"
                    v-model="filters.timeRange[0]"
                    full-width
                    format="24hr"
                  >
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="startTimeModal = false">
                      Cancel
                    </v-btn>
                    <v-btn
                      text
                      color="primary"
                      @click="$refs.startTimeDialog.save(filters.timeRange[0])"
                    >
                      OK
                    </v-btn>
                  </v-time-picker>
                </v-dialog>
                <v-dialog
                  ref="endTimeDialog"
                  v-model="endTimeModal"
                  :return-value.sync="filters.timeRange[1]"
                  persistent
                  width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="filters.timeRange[1]"
                      :disabled="!timeRangeEnabled"
                      :error-messages="errorMessage ?? ''"
                      label="End"
                      prepend-icon="mdi-clock-time-four-outline"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-time-picker
                    v-if="endTimeModal"
                    v-model="filters.timeRange[1]"
                    full-width
                    format="24hr"
                  >
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="endTimeModal = false">
                      Cancel
                    </v-btn>
                    <v-btn
                      text
                      color="primary"
                      @click="$refs.endTimeDialog.save(filters.timeRange[1])"
                    >
                      OK
                    </v-btn>
                  </v-time-picker>
                </v-dialog>
              </v-sheet>
            </v-sheet>
          </v-col>
          <v-col cols="12">
            <v-checkbox
              v-model="rememberFilters"
              label="Remember Filter Settings"
            >
            </v-checkbox>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-btn color="warning" text @click="$emit('close')">CANCEL</v-btn>
        <v-spacer></v-spacer>
        <v-btn color="success"  text @click="saveFilters">SAVE</v-btn>
      </v-card-actions>
    </v-card>
  </v-sheet>
</template>

<style scoped>
.filter {
  border: solid 2px var(--primary-color);
}
</style>
